import { InputGroup, List } from 'rsuite';
import styled from 'styled-components';
import Image from '../../Image';
import StoplightIndicator from '../../../StoplightIndicator';
import LinkedInventoryItemIcon from '../../../LinkedInventoryItemIcon';

export const StyledListItem = styled(List.Item)`
  padding: 0;
  margin: 16px;
  width: 140px;
  box-shadow: none;
  display: inline-block;
  border: 2px solid #ddd;
  border-radius: 8px;
  vertical-align: top;
  .rs-list-item-content {
    text-align: center;
    font-weight: 500;
    > p {
      margin: 15px 0;
    }
  }
  &.selected:not(.disabled) {
    border: 2px solid #f89645;
    .rs-input-group > .rs-input:not(.disabled) {
      border-top: 2px solid #f89645;
    }
    .rs-input-group > .rs-input-group-addon:first-child,
    .rs-input-group > .rs-input-group-addon:last-child {
      &:not(.disabled) {
        background-color: #f89645;
      }
      border-top: 2px solid #f89645;
    }
  }
  &.error {
    border: 2px solid #f44336;
    &::after {
      content: 'Exceeded inventory limit';
      width: 100%;
      bottom: -20px;
      display: block;
      color: #f44336;
      position: absolute;
    }
  }
  &.disabled {
    border: 2px solid #ddd;
  }
`;

export const StyledInputGroup = styled(InputGroup)`
  &:not(.rs-input-group-inside) {
    position: relative;
    border: none;
    border-radius: 0;
    > .rs-input {
      border-top: 2px solid #ddd;
      border-bottom: none;
    }
    > :first-child {
      width: 45px;
      color: #fff;
      cursor: pointer;
      background-color: #86cce7;
      border-top-left-radius: 0;
      &.disabled {
        cursor: default;
        background: #ccc;
      }
    }
    > :last-child {
      width: 45px;
      color: #fff;
      cursor: pointer;
      background-color: #86cce7;
      border-top-right-radius: 0;
      &.disabled {
        cursor: default;
        background: #ccc;
      }
    }
  }
`;

export const ItemPhoto = styled(Image)`
  margin-top: 10px;
  border-radius: 5px;
`;

export const HealthIndicator = styled(StoplightIndicator)`
  top: -7px;
  left: -7px;
  position: absolute;
  font-size: 18px;
`;

export const LinkedItemIcon = styled(LinkedInventoryItemIcon)`
  top: -6px;
  right: -7px;
  position: absolute;
  font-size: 16px;
`;

export const ItemLimit = styled.small`
  top: 5px;
  right: 6px;
  color: #8d8181;
  font-size: 9px;
  position: absolute;
  text-transform: capitalize;
`;
